export default function availableAggregations() {
   return [
      "sum",
      "average",
      "weighted average",
      "median",
      "min",
      "max",
      "variance",
      "skewness",
      "correlation",
      "spearman correlation",
      "standard deviation",
      "variance coefficient",
      "percentile",
      "number defined",
      "number undefined",
      "count",
      "distinct count",
   ];
}
